import React, { Component } from 'react';
import { withRouter, Redirect, BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import axios from 'axios';
import Moment from 'react-moment';
import { SelectOptions } from './SelectOptions';
import moment from 'moment';

class SAPMOCNotice extends Component {
    constructor (props) {
        super(props);
        this.state = {
            toQuestions: false,
            sapmocid: this.props.testid
        };
        this.submitNotice = this.submitNotice.bind(this)
    }
    componentDidMount() {
        axios({
            method: "get",
            url: `/api/notice/sapmoc_${this.state.sapmocid}`,
        }).then(res => {
            console.log(res)
            this.setState({noticeContent: res.data});
        })
        /*
        axios({
            method: "get",
            url: "/api/provinces",
        }).then(res => {
            this.setState({provinces: res.data.result});
        })
        axios({
            method: "get",
            url: "/api/countries",
        }).then(res => {
            this.setState({countries: res.data.result});
        })
        */
    }
    submitNotice = event => {
        event.preventDefault();
        if (this.state.satestid) {
            axios({
                method: "post",
                url: "/api/submitNoticeSAPMOC",
                data: {
                    testid: this.state.satestid
                }
            }).then(res => {
                window.location.reload();
                this.setState({toQuestions: true}, () => {});
            })
        }
    }

    render() {
        if (this.state.toQuestions === true) {
             return <Redirect to={`/sapmoc/sapmoc_${this.state.sapmocid}/questions`} />
        }
        return (
            <>
            <div className="row">
                <div className="col-xs-12" dangerouslySetInnerHTML={{__html: this.state.noticeContent}}>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <a href={`#`} onClick={this.submitNotice} className="btn btn-sm btn-primary">Begin Test</a>
                </div>
            </div>
            </>
        )
    }
}

export default SAPMOCNotice;

